import GmapVue, { components } from "gmap-vue";
import Vue from "vue";
var google_maps_default = ({ $config: { gmapId } }) => {
  Vue.use(GmapVue, {
    load: {
      key: gmapId,
      libraries: "places"
    },
    installComponents: true,
    dynamicLoad: false
  });
};
Vue.component("GmapCluster", components.Cluster);
export {
  google_maps_default as default
};
